<template>
<div class="containers">
    <div v-if="goArea == true" class="area-list">
        <CAlert
        v-if="success == true"
        :show.sync="currentAlertCounter"
        closeButton
        style="background-color:rgba(48, 107, 221, 1);border-radius:0;text-align:center;color:white"
        >
        {{alertMess}}
        </CAlert>
        <CAlert
        v-else
        :show.sync="currentAlertCounter"
        closeButton
        style="background-color:red;border-radius:0;text-align:center;color:white"
        >
        {{alertMess}}
        </CAlert>
        <div class="search-area">
            <CRow>
                <CCol sm="7">
                    <div class="autocomplete">
                        <input type="text"
                                class="form-control"
                                @click="toggleVisiblePegawai()"
                                @blur="toggleCloseVisiblePegawai()"
                                v-model="queryPegawai"
                                v-text="selectedItemPegawai ? selectedItemPegawai['text'] : ''"
                                @keydown.up="upPegawai"
                                @keydown.down="downPegawai"
                                @keydown.enter="selectItemPegawai"
                                placeholder="Pilih Pegawai"
                        >
                        <div class="popovers" v-show="visiblePegawai">
                            <div class="options" v-if="matchesPegawai.length != 0 && queryPegawai.length != 0" ref="optionsList">
                                <ul>
                                <li v-for="(match, index) in matchesPegawai"
                                    :key="index"
                                    :class="{ 'selected': (selectedPegawai == index)}"
                                    @click="itemClickedPegawai(index)"
                                    v-text="match['text']"></li>
                                </ul>
                            </div>
                            <div class="options" v-if="matchesPegawai.length == 0 && queryPegawai.length != 0">
                                Data Tidak Ditemukan
                            </div>
                            <div class="options" v-if="matchesPegawai.length == 0 && queryPegawai.length == 0">
                                Start Typing...
                            </div>
                        </div>
                    </div>
                </CCol>
                <CCol sm="3">
                    <model-select :options="searchDataFungsi"
                        style="background-color:rgba(249, 250, 252, 1)"
                        class="form-control model-select"
                        v-model="searchSelectedFungsi"
                        placeholder="Pilih Status Fungsi">
                    </model-select>
                </CCol>
                <CCol sm="2">
                    <CButton @click="findData()" type="button" class="btn btn-search">Cari</CButton>
                </CCol>
            </CRow>
        </div>
        <div class="sticky1">
            <CRow>
                <CCol sm="6">
                </CCol>
                <CCol sm="6">
                    <span style="float:right">
                        <CButton v-if="page == 1" disabled style="cursor:default" class="rounded"><font-awesome-icon :icon="{prefix: 'fas', iconName: 'chevron-left'}" /></CButton>
                        <CButton v-else @click="movePage('prev')" class="rounded"><font-awesome-icon :icon="{prefix: 'fas', iconName: 'chevron-left'}" /></CButton>
                        <CButton v-if="page == totalPage" style="cursor:default" disabled class="rounded"><font-awesome-icon :icon="{prefix: 'fas', iconName: 'chevron-right'}" /></CButton>
                        <CButton v-else @click="movePage('next')" class="rounded"><font-awesome-icon :icon="{prefix: 'fas', iconName: 'chevron-right'}" /></CButton>
                    </span>
                    <input @change="validatePage(page)" v-if="totalPage != 1" style="border: 1px solid rgba(154, 154, 154, 1);width:50px;float:right" v-model.number="page" class="text-center rounded p-1" type="text">
                    <input v-else disabled style="border: 1px solid rgba(154, 154, 154, 1);width:50px;float:right" v-model="page" class="text-center rounded p-1" type="text">
                    <span class="mr-3 mt-1" style="color:rgba(154, 154, 154, 1);float:right"><span style="color:rgba(16, 16, 16, 1)">{{firstPage}} - {{lastPage}}</span> of {{totalRow}}</span>
                </CCol>
                <!-- <CCol sm="2">
                    <CButton @click="moving()" type="button" class="btn btn-add">Tambah</CButton>
                </CCol> -->
            </CRow>
        </div>
        <Tables @sort="sorting" @edit="editData" :data="datas" :th="dataTh" :td="dataTd" :styleTable="styleTable" :errors="errorMessage"></Tables>
    </div>
    <div v-else class="area-edit">
        <CModal
            size="sm"
            :centered="true"
            title="Info Delete"
            color="danger"
            :show.sync="deleteModal"
            :closeOnBackdrop="false"
            >
            <p>Apakah anda yakin ingin menghapus Data?</p>
            <CRow>
                <CCol sm="6">
                    <CButton @click="cancelDelete()" class="btn btn-secondary w-100 text-center btn-cancel">Batal</CButton>
                </CCol>
                <CCol sm="6">
                    <CButton @click="onDelete()" class="btn btn-danger w-100 text-center btn-delete">Ya, Hapus</CButton>
                </CCol>
            </CRow>
            <template #footer-wrapper><span></span></template>
        </CModal>
        <CModal
            size="lg"
            :centered="true"
            color="white"
            :show.sync="umpModal"
            :closeOnBackdrop="false"
            >
            <template #header-wrapper>
                <div class="headers-modal">
                    <CRow>
                        <CCol sm="10">
                            <div>Daftar Upah Minimum Provinsi</div>
                        </CCol>
                        <CCol sm="2" class="text-right">
                            <img :src="closeIcon" @click="umpModal = false" style="cursor:pointer" width="20px" height="20px"/>
                        </CCol>
                    </CRow>
                </div>
            </template>
            <template #body-wrapper>
                <div class="mb-5" style="padding-right:20px;padding-left:20px">
                    <CRow>
                        <CCol sm="12">
                            <table style="border-color:gainsboro!important" class="table table-bordered table-light w-100">
                                <thead>
                                    <tr class="text-center">
                                        <th style="border-color:gainsboro!important">Nama Provinsi</th>
                                        <th style="border-color:gainsboro!important">UMP</th>
                                        <th style="border-color:gainsboro!important">Action</th>
                                    </tr>
                                </thead>
                                <tbody v-if="dataUMP.length != 0">
                                    <tr v-for="(ol, id) in dataUMP" :key="id">
                                        <td style="border-color:gainsboro!important;text-align:left" class="font-weight-bold">{{ol.provinsi}}</td>
                                        <td style="border-color:gainsboro!important;text-align:right">{{separatorUMP(ol.totalUmr)}}</td>
                                        <td style="border-color:gainsboro!important" class="text-center"><CButton @click="pickUMP(id)" class="w-100" color="secondary" variant="outline">Pilih</CButton></td>
                                    </tr>
                                </tbody>
                                <tbody v-else>
                                    <tr>
                                        <td colspan="3">
                                            {{errMessage}}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </CCol>
                    </CRow>
                </div>
            </template>
            <template #footer-wrapper><span></span></template>
        </CModal>
        <CRow class="area-back">
            <CCol sm="12">
                <img class="mt-2 mb-2" @click="moving()" :src="backIcon" width="20px" height="20px" style="float:left;cursor:pointer"/>
            </CCol>
        </CRow>
        <hr style="border: 1px solid rgba(238, 238, 238, 1)" class="p-0 m-0"/>
        <CRow class="area-input">
            <CCol sm="12">
                <CRow>
                    <CCol sm="6">
                        <label>Nama Pegawai</label>
                        <div class="autocomplete">
                            <input type="text"
                                    :disabled="tipe == 'U'"
                                    class="form-control"
                                    @click="toggleVisibleAddPegawai()"
                                    @blur="toggleCloseVisibleAddPegawai()"
                                    v-model.trim="$v.queryAddPegawai.$model"
                                    :class="{ 'is-invalid':$v.queryAddPegawai.$error, 'is-valid': !$v.queryAddPegawai.$invalid }"
                                    v-text="selectedItemAddPegawai ? selectedItemAddPegawai['text'] : ''"
                                    @keydown.up="upAddPegawai"
                                    @keydown.down="downAddPegawai"
                                    @keydown.enter="selectItemAddPegawai"
                                    placeholder="Pilih Pegawai"
                            >
                            <div class="popovers" v-show="visibleAddPegawai">
                                <div class="options" v-if="matchesAddPegawai.length != 0 && queryAddPegawai.length != 0" ref="optionsList">
                                    <ul>
                                    <li v-for="(match, index) in matchesAddPegawai"
                                        :key="index"
                                        :class="{ 'selected': (selectedAddPegawai == index)}"
                                        @click="itemClickedAddPegawai(index)"
                                        v-text="match['text']"></li>
                                    </ul>
                                </div>
                                <div class="options" v-if="matchesAddPegawai.length == 0 && queryAddPegawai.length != 0">
                                    Data Tidak Ditemukan
                                </div>
                                <div class="options" v-if="matchesAddPegawai.length == 0 && queryAddPegawai.length == 0">
                                    Start Typing...
                                </div>
                            </div>
                        </div>
                    </CCol>
                    <CCol sm="3">
                        <label>Export Certificate</label>
                        <CButton @click="showCertificate()" class="w-100" color="danger" variant="outline">Certificate</CButton>
                    </CCol>
                    <CCol sm="3">
                        <label>Export Letter</label>
                        <CButton @click="showLetter()" class="w-100" color="danger" variant="outline">Letter of Statement</CButton>
                    </CCol>
                </CRow>
                <CRow class="mt-3">
                    <CCol sm="4">
                        <label>Nominal Uang Saku (Bulan)</label>
                        <input 
                            class="form-control" 
                            v-model.trim="$v.uangSaku.$model"
                            @input="rupiahModeUangSaku('saku')"
                            :class="{ 'is-invalid':$v.uangSaku.$error, 'is-valid': !$v.uangSaku.$invalid }"
                            onkeypress="return (event.charCode !=8 && event.charCode ==0 || (event.charCode >= 48 && event.charCode <= 57))" 
                            placeholder="Uang Saku"
                            type="text"
                        />
                    </CCol>
                    <CCol sm="2">
                        <label>UMP</label>
                        <CButton @click="umpModal = true" class="w-100" color="primary" variant="outline">Pilih UMP</CButton>
                    </CCol>
                    <CCol sm="6">
                        <label>Nominal Uang Makan (Hari)</label>
                        <input 
                            class="form-control" 
                            v-model.trim="$v.uangMakan.$model"
                            @input="rupiahModeUangSaku('makan')"
                            :class="{ 'is-invalid':$v.uangMakan.$error, 'is-valid': !$v.uangMakan.$invalid }"
                            onkeypress="return (event.charCode !=8 && event.charCode ==0 || (event.charCode >= 48 && event.charCode <= 57))" 
                            placeholder="Uang Makan"
                            type="text"
                        />
                    </CCol>
                </CRow>
                <CRow>
                    <CCol sm="6">
                        <label>Nominal Uang Komunikasi (Bulan)</label>
                        <input 
                            class="form-control" 
                            v-model.trim="$v.uangKomunikasi.$model"
                            @input="rupiahModeUangSaku('komunikasi')"
                            :class="{ 'is-invalid':$v.uangKomunikasi.$error, 'is-valid': !$v.uangKomunikasi.$invalid }"
                            onkeypress="return (event.charCode !=8 && event.charCode ==0 || (event.charCode >= 48 && event.charCode <= 57))" 
                            placeholder="Uang Komunikasi"
                            type="text"
                        />
                    </CCol>
                    <CCol sm="6">
                        <label>Nominal Uang Reimburse</label>
                        <input 
                            class="form-control" 
                            v-model.trim="$v.uangReimburse.$model"
                            @input="rupiahModeUangSaku('reimburse')"
                            :class="{ 'is-invalid':$v.uangReimburse.$error, 'is-valid': !$v.uangReimburse.$invalid }"
                            onkeypress="return (event.charCode !=8 && event.charCode ==0 || (event.charCode >= 48 && event.charCode <= 57))" 
                            placeholder="Uang Reimburse"
                            type="text"
                        />
                    </CCol>
                </CRow>
                <CRow>
                    <CCol sm="6">
                        <label>Suplisi (bulan)</label>
                        <input 
                            class="form-control" 
                            v-model="suplisi"
                            @input="rupiahModeUangSaku('suplisi')"
                            placeholder="suplisi"
                            onkeypress="return (event.charCode !=8 && event.charCode ==0 || (event.charCode >= 48 && event.charCode <= 57))" 
                            type="text"
                        />
                    </CCol>
                </CRow>
                <CRow>
                    <CCol sm="6">
                        <label>Iuran BPJS (bulan)</label>
                        <input 
                            class="form-control" 
                            v-model="iuranBpjs"
                            @input="rupiahModeUangSaku('iuranBpjs')"
                            placeholder="Iuran BPJS"
                            onkeypress="return (event.charCode !=8 && event.charCode ==0 || (event.charCode >= 48 && event.charCode <= 57))" 
                            type="text"
                        />
                    </CCol>
                    <CCol sm="6">
                        <label>Faktor Pengurang</label>
                        <input 
                            class="form-control" 
                            v-model="faktorPengurang"
                            @input="rupiahModeUangSaku('faktorPengurang')"
                            onkeypress="return (event.charCode !=8 && event.charCode ==0 || (event.charCode >= 48 && event.charCode <= 57))" 
                            placeholder="Faktor Pengurang"
                            type="text"
                        />
                    </CCol>
                </CRow>
                <CRow>
                    <CCol sm="12">
                        <span style="font-size:12px">*Catatan: Jika tidak ada nominal yang dibayarkan harap isi dengan 'Rp. 0'
                    </CCol>
                </CRow>
                <hr/>
                <CRow class="mt-3">
                    <CCol sm="6">
                        <label>Nomor Perjanjian Magang</label>
                        <input 
                            class="form-control"
                            v-model="nomorPerjanjian"
                            placeholder="Nomor Perjanjian"
                            type="text"
                        />
                    </CCol>
                    <CCol sm="6">
                        <label>Nomor MI Penerimaan Magang</label>
                        <input 
                            class="form-control" 
                            v-model="nomorMI"
                            placeholder="Nomor MI"
                            type="text"
                        />
                    </CCol>
                </CRow>
                <CRow>
                    <CCol sm="6">
                        <label>Tanggal Aktif</label>
                        <input 
                            class="form-control mr-2"
                            v-model.trim="$v.tanggalAktif.$model"
                            :class="{ 'is-invalid':$v.tanggalAktif.$error, 'is-valid': !$v.tanggalAktif.$invalid }"
                            placeholder="Tanggal Aktif"
                            type="date"
                        />
                    </CCol>
                    <CCol sm="6">
                        <label>Tanggal Non Aktif</label>
                        <input 
                            :disabled="tanggalAktif == ''"
                            class="form-control" 
                            :min="tanggalAktif"
                            v-model.trim="$v.tanggalNonAktif.$model"
                            :class="{ 'is-invalid':$v.tanggalNonAktif.$error, 'is-valid': !$v.tanggalNonAktif.$invalid }"
                            placeholder="Tanggal Non Aktif"
                            type="date"
                        />
                    </CCol>
                </CRow>
                <hr/>
                <CRow class="mt-3">
                    <CCol sm="6">
                        <label>Status Fungsi</label>
                        <model-select :options="dataFungsi"
                            class="form-control model-select"
                            v-model.trim="$v.selectedFungsi.$model"
                            :class="{ 'is-invalid select-invalid':$v.selectedFungsi.$error, 'is-valid select-valid': !$v.selectedFungsi.$invalid }"
                            placeholder="Pilih Status Fungsi">
                        </model-select>
                    </CCol>
                    <CCol sm="6">
                        <label>Cost Center</label>
                        <input 
                            class="form-control" 
                            v-model="costCenter"
                            placeholder="Cost Center"
                            type="text"
                        />
                    </CCol>
                </CRow>
                <hr/>
                <CRow class="mt-3">
                    <CCol sm="6">
                        <label>PRK</label>
                        <input 
                            class="form-control"
                            v-model="prk"
                            placeholder="PRK"
                            type="text"
                        />
                    </CCol>
                    <CCol sm="6">
                        <label>IO</label>
                        <input 
                            class="form-control"
                            v-model="io"
                            placeholder="IO"
                            type="text"
                        />
                    </CCol>
                </CRow>
                <CRow class="mt-3">
                    <CCol sm="6">
                        <label>CoA</label>
                        <input 
                            class="form-control"
                            v-model="coa"
                            placeholder="CoA"
                            type="text"
                        />
                    </CCol>
                </CRow>
                <CRow>
                    <CCol sm="6">
                        <label>Sekolah</label>
                        <input 
                            class="form-control"
                            v-model.trim="$v.sekolah.$model"
                            :class="{ 'is-invalid':$v.sekolah.$error, 'is-valid': !$v.sekolah.$invalid }"
                            placeholder="Sekolah"
                            type="text"
                        />
                    </CCol>
                    <CCol sm="6">
                        <label>Keterangan</label>
                        <input 
                            class="form-control"
                            v-model="keterangan"
                            placeholder="Keterangan"
                            type="text"
                        />
                    </CCol>
                </CRow>
                <hr/>
                <CRow class="mt-3">
                    <CCol sm="6">
                        <label>Nomor Rekening</label>
                        <input 
                            class="form-control mr-2"
                            v-model.trim="$v.nomorRekening.$model"
                            :class="{ 'is-invalid':$v.nomorRekening.$error, 'is-valid': !$v.nomorRekening.$invalid }"
                            onkeypress="return (event.charCode !=8 && event.charCode ==0 || (event.charCode >= 48 && event.charCode <= 57))" 
                            placeholder="Nomor Rekening"
                            type="text"
                        />
                    </CCol>
                    <CCol sm="6">
                        <label>Nama Bank</label>
                        <input 
                            class="form-control" 
                            v-model.trim="$v.namaBank.$model"
                            :class="{ 'is-invalid':$v.namaBank.$error, 'is-valid': !$v.namaBank.$invalid }"
                            placeholder="Nama Bank"
                            type="text"
                        />
                    </CCol>
                </CRow>
                <CRow>
                    <CCol sm="6">
                        <label>Nama Pemilik Rekening</label>
                        <input 
                            class="form-control"
                            v-model.trim="$v.namaPemilik.$model"
                            :class="{ 'is-invalid':$v.namaPemilik.$error, 'is-valid': !$v.namaPemilik.$invalid }"
                            placeholder="Nama Pemilik Rekening"
                            type="text"
                        />
                    </CCol>
                </CRow>
            </CCol>
        </CRow>
        <CRow class="area-button-submit">
            <CCol sm="12">
                <CButton v-if="tipe != 'C'" @click="goDelete()" class="btn btn-edit-delete mr-2">
                    <span>Delete</span>
                </CButton>
                <CButton @click="submitForm()" class="btn btn-edit-submit">
                    <span v-if="loading == false">Submit</span>
                    <CSpinner v-else color="default" size="sm"/>
                </CButton>
            </CCol>
        </CRow>
    </div>
</div>
</template>

<script>
import Tables from '../../../component/tableMagang'
import {DataApi} from "../../../service/DataApi";
import { required, minLength, maxLength } from 'vuelidate/lib/validators'
import { validationMixin } from 'vuelidate'
import { ModelSelect } from 'vue-search-select'
export default {
    components: {
        Tables,
        ModelSelect
    },
    mixins: [validationMixin],
    validations: {
        queryAddPegawai: {
            required
        },
        uangSaku: {
            required
        },
        uangMakan: {
            required
        },
        uangKomunikasi: {
            required
        },
        tanggalAktif: {
            required
        },
        tanggalNonAktif: {
            required
        },
        selectedFungsi: {
            value: {
                required
            },
            text: {
                required
            }
        },
        uangReimburse: {
            required
        },
        sekolah: {
            required
        },
        nomorRekening: {
            required
        },
        namaBank: {
            required
        },
        namaPemilik: {
            required
        },
    },
    data() {
        return {
            success: true,
            itemHeight: 39,
            
            // data search pegawai
            dataPegawai: [],
            titlePegawai:"Pilih Pegawai",
            selectedItemPegawai: null,
            selectedPegawai: 0,
            queryPegawai: '',
            visiblePegawai: false,
            idPegawai: '',

            // data search add pegawai
            dataAddPegawai: [],
            titleAddPegawai:"Pilih Pegawai",
            selectedItemAddPegawai: null,
            selectedAddPegawai: 0,
            queryAddPegawai: '',
            visibleAddPegawai: false,
            idAddPegawai: '',

            // datas
            refreshIcon: require('../../../assets/menu/icon_refresh.svg'),
            backIcon: require('../../../assets/menu/icon_goback.svg'),
            moreIcon: require('../../../assets/menu/icon_more.svg'),
            closeIcon: require('../../../assets/menu/icon_close.svg'),
            dataTh: ['Nama / NIP', 'Uang Saku', 'Uang Makan', 'Komunikasi', 'Tanggal Masuk', 'Tanggal Keluar', 'Status', 'Fungsi', 'Action'],
            dataTd: [['nama', 'nik'], 'uangSaku', 'uangMakan', 'uangKomunikasi', 'tglAktif', 'tglNonAktif', 'aktif', 'fungsi', 'action'],
            styleTable: ['200px', '100px', '100px', '100px', '75px', '75px', '75px', '75px', '100px' ],
            classReload: 'reloadOff',
            datas: [],
            goArea: true,
            loading: false,
            alertMess: '',
            currentAlertCounter: 0,
            constDay: 1,
            editSession: false,

            uangSaku: '',
            uangMakan: '',
            tanggalAktif: '',
            tanggalNonAktif: '',
            uangKomunikasi: '',
            tipe: 'C',
            unix: '',
            dataFungsi: [],
            selectedFungsi: {
                text: '',
                value: ''
            },
            searchDataFungsi: [],
            searchSelectedFungsi: {
                text: '',
                value: ''
            },
            uangReimburse: '',
            sekolah: '',
            nomorRekening: '',
            namaBank: '',
            namaPemilik: '',
            prk: '',
            io: '',
            coa: '',
            suplisi: '',
            nomorMI: '',
            nomorPerjanjian: '',
            iuranBpjs: '',
            faktorPengurang: '',
            costCenter: '',
            keterangan: '',
            idPegawaiEdit: '',


            // paging
            page: 1,
            size: 20,
            totalRow: 0,
            totalPage: 1,
            firstPage: 0,
            lastPage: 0,

            // error
            errorMessage: '',
            deleteModal: false,

            umpModal: false,
            errMessage: '',
            dataUMP: [],
            flagSearch: false
        }
    },
    computed: {
        matchesPegawai() {
            if (this.queryPegawai == '') {
                return [];
            }
            return this.dataPegawai.filter((item) => item['text'].toLowerCase().includes(this.queryPegawai.toLowerCase()))
        },
        matchesAddPegawai() {
            if (this.queryAddPegawai == '') {
                return [];
            }
            return this.dataAddPegawai.filter((item) => item['text'].toLowerCase().includes(this.queryAddPegawai.toLowerCase()))
        },
        
    },
    watch: {
        page() {
            window.scroll({
                top:0,
                left: 0,
                behavior: 'smooth'
            });
        },
        queryPegawai() {
            if(this.queryPegawai == '') {
                this.idPegawai = ''
            }
            this.flagSearch = true
            this.getDataPegawai()
        },
        queryAddPegawai() {
            if(this.queryAddPegawai == '') {
                this.idAddPegawai = ''
                this.tanggalAktif = ''
                this.tanggalNonAktif = ''
            }
            this.getDataAddPegawai('null')
        },
        searchSelectedFungsi() {
            this.flagSearch = true
        },
        selectedFungsi() {
            this.prk = ''
            this.io = ''
        },
        goArea() {
            window.scroll({
                top:0,
                left: 0,
                behavior: 'smooth'
            });
        }
    },
    methods: {
        rupiahModeUangSaku(val) {
            let angka
            if(val == 'saku') {
                angka = this.uangSaku
            } else if(val == 'makan') {
                angka = this.uangMakan
            } else if(val == 'komunikasi') {
                angka = this.uangKomunikasi
            } else if(val == 'reimburse') {
                angka = this.uangReimburse
            }else if(val == 'suplisi') {
                angka = this.suplisi
            } else if(val == 'iuranBpjs') {
                angka = this.iuranBpjs
            } else if(val == 'faktorPengurang') {
                angka = this.faktorPengurang
            }
            var number_string = angka.toString().replace(/[^,\d]/g, '')
            var split           = number_string.split(',')
            var sisa             = split[0].length % 3
            var rupiah             = split[0].substr(0, sisa)
            var ribuan             = split[0].substr(sisa).match(/\d{3}/gi)
            var prefix = "Rp. "
        
            // tambahkan titik jika yang di input sudah menjadi angka satuan ribuan
            if(ribuan){
                var separator = sisa ? '.' : '';
                rupiah += separator + ribuan.join('.');
            }
        
            rupiah = split[1] != undefined ? rupiah + ',' + split[1] : rupiah;
            let hasil = prefix == undefined ? rupiah : (rupiah ? 'Rp. ' + rupiah : '');
            if(val == 'saku') {
                this.uangSaku = hasil
            } else if(val == 'makan') {
                this.uangMakan = hasil
            } else if(val == 'komunikasi') {
                this.uangKomunikasi = hasil
            } else if(val == 'reimburse') {
                this.uangReimburse = hasil
            } else if(val == 'suplisi') {
                this.suplisi = hasil
            } else if(val == 'iuranBpjs') {
                this.iuranBpjs = hasil
            } else if(val == 'faktorPengurang') {
                this.faktorPengurang = hasil
            }
        },
        /**
         * SEARCH PEGAWAI
         */
        getDataPegawai() {
            let payload = {
                bidang: '',
                jabatan: '',
                limit: 10,
                nama: this.queryPegawai,
                pageIn: 1,
                pegawaiId: '',
                tipePegawai: '3'
            }
            DataApi.post("pegawai/get", payload)
            .then(res => {
                this.dataPegawai = []
                let response = res.data
                let tempData = response.data.data
                var i = 0;
                for(i=0;i<tempData.length;i++) {
                    let onPush = {
                        value: tempData[i].idPegawai,
                        text: tempData[i].nama + ' - ' + tempData[i].nik
                    }
                    this.dataPegawai.push(onPush)
                }
            })
        },

        toggleVisiblePegawai() {
            this.visiblePegawai = true;
        },
        hidePegawai() {
            this.visiblePegawai = false;
        },
        toggleCloseVisiblePegawai() {
            setTimeout(this.hidePegawai, 1000);
        },
        itemClickedPegawai(index) {
            this.selectedPegawai = index;
            this.selectItemPegawai();
        },
        selectItemPegawai() {
            if (!this.matchesPegawai.length) {
            return;
            }
            this.selectedItemPegawai = this.matchesPegawai[this.selectedPegawai];
            this.visiblePegawai = false;
            this.queryPegawai = this.selectedItemPegawai.text
            this.idPegawai = this.selectedItemPegawai.value
            if (this.shouldReset) {
            this.queryPegawai = '';
            this.selectedPegawai = 0;
            }
        },
        upPegawai() {
            if (this.selectedPegawai == 0) {
            return;
            }
            this.selectedPegawai -= 1;
            this.scrollToItemPegawai();
        },
        downPegawai() {
            if (this.selectedPegawai >= this.matchesPegawai.length - 1) {
            return;
            }
            this.selectedPegawai += 1;
            this.scrollToItemPegawai();
        },
        scrollToItemPegawai() {
            this.$refs.optionsList.scrollTop = this.selectedPegawai * this.itemHeight;
        },


        getDataAddPegawai(val) {
            let payload = ''
            if(val == 'null') {
                payload = {
                    bidang: '',
                    jabatan: '',
                    limit: 10,
                    nama: this.queryAddPegawai,
                    pageIn: 1,
                    pegawaiId: '',
                    tipePegawai: '3'
                }
            } else {
                payload = {
                    bidang: '',
                    jabatan: '',
                    limit: 10,
                    nama: '',
                    pageIn: 1,
                    pegawaiId: val,
                    tipePegawai: '3'
                }
            }
            DataApi.post("pegawai/get", payload)
            .then(res => {
                this.dataAddPegawai = []
                let response = res.data
                let tempData = response.data.data
                var i = 0;
                for(i=0;i<tempData.length;i++) {
                    let onPush = {
                        tglAktif: tempData[i].tglAktif.split(' ')[0],
                        tglNonAktif: tempData[i].tglNonAktif.split(' ')[0], 
                        value: tempData[i].idPegawai,
                        text: tempData[i].nama + ' - ' + tempData[i].nik
                    }
                    this.dataAddPegawai.push(onPush)
                }
                if(val != 'null') {
                    this.queryAddPegawai = this.dataAddPegawai[0].text
                    this.idAddPegawai = val
                    if(this.tipe == 'C') {
                        this.tanggalAktif = this.dataAddPegawai[0].tglAktif
                        this.tanggalNonAktif = this.dataAddPegawai[0].tglNonAktif
                    }
                }
            })
        },

        toggleVisibleAddPegawai() {
            this.visibleAddPegawai = true;
        },
        hideAddPegawai() {
            this.visibleAddPegawai = false;
        },
        toggleCloseVisibleAddPegawai() {
            setTimeout(this.hideAddPegawai, 1000);
        },
        itemClickedAddPegawai(index) {
            this.selectedAddPegawai = index;
            this.selectItemAddPegawai();
        },
        selectItemAddPegawai() {
            if (!this.matchesAddPegawai.length) {
            return;
            }
            this.selectedItemAddPegawai = this.matchesAddPegawai[this.selectedAddPegawai];
            this.visibleAddPegawai = false;
            this.queryAddPegawai = this.selectedItemAddPegawai.text
            this.idAddPegawai = this.selectedItemAddPegawai.value
            this.tanggalAktif = this.selectedItemAddPegawai.tglAktif
            this.tanggalNonAktif = this.selectedItemAddPegawai.tglNonAktif
            if (this.shouldReset) {
            this.queryAddPegawai = '';
            this.selectedAddPegawai = 0;
            }
        },
        upAddPegawai() {
            if (this.selectedAddPegawai == 0) {
            return;
            }
            this.selectedAddPegawai -= 1;
            this.scrollToItemAddPegawai();
        },
        downAddPegawai() {
            if (this.selectedAddPegawai >= this.matchesAddPegawai.length - 1) {
            return;
            }
            this.selectedAddPegawai += 1;
            this.scrollToItemAddPegawai();
        },
        scrollToItemAddPegawai() {
            this.$refs.optionsList.scrollTop = this.selectedAddPegawai * this.itemHeight;
        },


        sorting(value) {
            if(value == 0) {
                function compare(a,b) {
                    if (a.nama.toLowerCase() < b.nama.toLowerCase()) {
                        return -1
                    }
                    if (a.nama.toLowerCase() > b.nama.toLowerCase()) {
                        return 1
                    }
                    return 0
                }
                return this.datas.sort(compare)
            } else if(value == 1) {
                function compare(a,b) {
                    if (a.hkp.toLowerCase() < b.hkp.toLowerCase()) {
                        return -1
                    }
                    if (a.hkp.toLowerCase() > b.hkp.toLowerCase()) {
                        return 1
                    }
                    return 0
                }
                return this.datas.sort(compare)
            } else if(value == 2) {
                function compare(a,b) {
                    if (a.uangSaku.toLowerCase() < b.uangSaku.toLowerCase()) {
                        return -1
                    }
                    if (a.uangSaku.toLowerCase() > b.uangSaku.toLowerCase()) {
                        return 1
                    }
                    return 0
                }
                return this.datas.sort(compare)
            } else if(value == 3) {
                function compare(a,b) {
                    if (a.uangMakan.toLowerCase() < b.uangMakan.toLowerCase()) {
                        return -1
                    }
                    if (a.uangMakan.toLowerCase() > b.uangMakan.toLowerCase()) {
                        return 1
                    }
                    return 0
                }
                return this.datas.sort(compare)
            } else if(value == 4) {
                function compare(a,b) {
                    if (a.uangKomunikasi.toLowerCase() < b.uangKomunikasi.toLowerCase()) {
                        return -1
                    }
                    if (a.uangKomunikasi.toLowerCase() > b.uangKomunikasi.toLowerCase()) {
                        return 1
                    }
                    return 0
                }
                return this.datas.sort(compare)
            } else if(value == 5) {
                function compare(a,b) {
                    if (a.mangkir.toLowerCase() < b.mangkir.toLowerCase()) {
                        return -1
                    }
                    if (a.mangkir.toLowerCase() > b.mangkir.toLowerCase()) {
                        return 1
                    }
                    return 0
                }
                return this.datas.sort(compare)
            } else if(value == 6) {
                function compare(a,b) {
                    if (a.gaji.toLowerCase() < b.gaji.toLowerCase()) {
                        return -1
                    }
                    if (a.gaji.toLowerCase() > b.gaji.toLowerCase()) {
                        return 1
                    }
                    return 0
                }
                return this.datas.sort(compare)
            }
        },
        getData() {
            if(this.flagSearch == true) {
                this.page = 1
            }
            this.$store.state.loadingScreen = true
            let payload = {
                idPegawai: this.idPegawai,
                limit: this.size,
                nama: '',
                pageIn: this.page,
                fungsi: this.searchSelectedFungsi.value
            }
            DataApi.post("magang/get", payload)
            .then(res => {
                let response = res.data
                if(response.success == true) {
                    this.datas = response.data.data
                    this.totalRow = response.data.totalRow
                    this.firstPage = (((this.page - 1) * this.size) + 1 )
                    this.lastPage = (((this.page - 1) * this.size) + this.datas.length )
                    this.totalPage = Math.floor(this.totalRow/this.size)
                    let modAr = this.totalRow%this.size
                    if(modAr != 0) {
                        this.totalPage = this.totalPage + 1
                    } else {
                        //
                    }
                    // this.dataDownload()
                } else {
                    this.datas = []
                    this.totalRow = 0
                    this.firstPage = 0
                    this.lastPage = 0
                    this.totalPage = 1
                    this.errorMessage = response.message
                }
                this.flagSearch = false
                this.$store.state.loadingScreen = false
            })
        },
        findData() {
            this.getData()
        },
        reload() {
            this.searchValue = ''
            this.selectedBulan.value = ''
            this.selectedBulan.text = ''
            this.getDataBulan()
            this.flagSearch = true
            if (this.classReload == 'reloadOff') {
                this.classReload = 'reloadOn'
            } else {
                this.classReload = 'reloadOff'
            }
            this.getData()
        },
        movePage(direction) {
            if(direction == 'prev') {
                this.page = this.page -  1
            } else {
                this.page = this.page +  1
            }
            this.getData()
        },
        validatePage(page) {
            if(page > this.totalPage) {
                this.page = this.totalPage
            }
        },
        moving() {
            setTimeout(this.moveArea, 300);
        },
        moveArea() {
            if(this.goArea == true) {
                this.goArea = false
            } else {
                this.goArea = true
                this.tanggalAktif = ''
                this.tanggalNonAktif = ''
                this.idPegawai = ''
                this.uangMakan = ''
                this.uangSaku = ''
                this.uangKomunikasi = ''
                this.suplisi = ''
                this.iuranBpjs = ''
                this.faktorPengurang = ''
                this.queryAddPegawai = ''
                this.selectedFungsi.value = ''
                this.selectedFungsi.text = ''
                this.uangReimburse = ''
                this.sekolah = ''
                this.nomorRekening = ''
                this.namaBank = ''
                this.namaPemilik = ''
                this.prk = ''
                this.io = ''
                this.keterangan = ''
                this.costCenter = ''
                this.nomorMI = ''
                this.nomorPerjanjian = ''
                this.tipe = 'C'
                this.unix = 0
                this.idPegawaiEdit = ''
                this.getDataFungsi()
                this.$v.$reset()
            }
        },

        goSave() {
            let uangSaku = ''
            let clear = ''
            if(this.uangSaku[0] == 'R') {
                clear = this.uangSaku.replace("Rp. ", '')
                var i
                for(i=0;i<clear.length;i++) {
                    if(clear[i] == '.') {
                        //
                    } else {
                        uangSaku += clear[i]
                    }
                }
            } else {
                uangSaku = this.uangSaku
            }
            let uangMakan = ''
            let clear1 = ''
            if(this.uangMakan[0] == 'R') {
                clear1 = this.uangMakan.replace("Rp. ", '')
                var j
                for(j=0;j<clear1.length;j++) {
                    if(clear1[j] == '.') {
                        //
                    } else {
                        uangMakan += clear1[j]
                    }
                }
            } else {
                uangMakan = this.uangMakan
            }
            let uangKomunikasi = ''
            let clear2 = ''
            if(this.uangKomunikasi[0] == 'R') {
                clear2 = this.uangKomunikasi.replace("Rp. ", '')
                var k
                for(k=0;k<clear2.length;k++) {
                    if(clear2[k] == '.') {
                        //
                    } else {
                        uangKomunikasi += clear2[k]
                    }
                }
            } else {
                uangKomunikasi = this.uangKomunikasi
            }

            let uangReimburse = ''
            let clear3 = ''
            if(this.uangReimburse[0] == 'R') {
                clear3 = this.uangReimburse.replace("Rp. ", '')
                var l
                for(l=0;l<clear3.length;l++) {
                    if(clear3[l] == '.') {
                        //
                    } else {
                        uangReimburse += clear3[l]
                    }
                }
            } else {
                uangReimburse = this.uangReimburse
            }

            let suplisi = ''
            let clear4 = ''
            if(this.suplisi[0] == 'R') {
                clear4 = this.suplisi.replace("Rp. ", '')
                var m
                for(m=0;m<clear4.length;m++) {
                    if(clear4[m] == '.') {
                        //
                    } else {
                        suplisi += clear4[m]
                    }
                }
            } else {
                suplisi = this.suplisi
            }

            let iuranBpjs = ''
            let clear5 = ''
            if(this.iuranBpjs[0] == 'R') {
                clear5 = this.iuranBpjs.replace("Rp. ", '')
                var n
                for(n=0;n<clear5.length;n++) {
                    if(clear5[n] == '.') {
                        //
                    } else {
                        iuranBpjs += clear5[n]
                    }
                }
            } else {
                iuranBpjs = this.iuranBpjs
            }

            let faktorPengurang = ''
            let clear6 = ''
            if(this.faktorPengurang[0] == 'R') {
                clear6 = this.faktorPengurang.replace("Rp. ", '')
                var o
                for(o=0;o<clear6.length;o++) {
                    if(clear6[o] == '.') {
                        //
                    } else {
                        faktorPengurang += clear6[o]
                    }
                }
            } else {
                faktorPengurang = this.faktorPengurang
            }

            let tipe = ''
            if(this.deleteModal == true) {
                tipe = 'D'
            } else {
                tipe = this.tipe
            }
            let fungsi = this.selectedFungsi.value
            let payload = { 
                bpjs: iuranBpjs,
                contactCenter: this.costCenter,
                keterangan: this.keterangan,
                nomorMi: this.nomorMI,
                nomorPerjanjian: this.nomorPerjanjian,
                pengurang: faktorPengurang,
                suplisi: suplisi,
                idPegawai: this.idAddPegawai,
                tglAktif: this.tanggalAktif,
                tglNonAktif: this.tanggalNonAktif,
                tipe: tipe,
                uangKomunikasi: uangKomunikasi,
                uangMakan: uangMakan,
                uangSaku: uangSaku,
                coa: this.coa,
                fungsi: fungsi,
                unix: this.unix,
                io: this.io,
                prk: this.prk,
                sekolah: this.sekolah,
                namaBank: this.namaBank,
                namaPemilikRek: this.namaPemilik,
                noRek: this.nomorRekening,
                reimburse: uangReimburse
            }
            DataApi.post("magang/save", payload)
            .then(res => {
                let response = res.data
                if(response.success == true) {
                    if(response.data.Data1 == 'Y') {
                        this.success = true
                    } else {
                        this.success = false
                    }
                    this.alertMess = response.data.Data2
                } else {
                    this.alertMess = response.message
                    this.success = false
                }
                this.deleteModal = false
                this.getData()
                this.moving()
                this.loading = false
                this.currentAlertCounter = 7
            })
        },
        editData(value) {
            let generate = this.datas[value]
            this.uangSaku = generate.uangSaku
            this.uangMakan = generate.uangMakan
            this.uangKomunikasi = generate.uangKomunikasi
            this.suplisi = generate.suplisi
            this.faktorPengurang = generate.pengurang
            this.iuranBpjs = generate.bpjs
            this.tanggalAktif = generate.tglAktif
            if(generate.tglNonAktif == 'null') {
                this.tanggalNonAktif = ''
            } else {
                this.tanggalNonAktif = generate.tglNonAktif
            }
            this.uangReimburse = generate.reimburse
            this.sekolah = generate.sekolah
            this.nomorRekening = generate.noRek
            this.namaBank = generate.namaBank
            this.nomorMI = generate.nomorMi
            this.nomorPerjanjian = generate.nomorPerjanjian
            this.keterangan = generate.keterangan
            this.costCenter = generate.contactCenter
            this.namaPemilik = generate.namaPemilikRek
            this.prk = generate.prk
            this.coa = generate.coa
            this.io = generate.io
            this.idPegawaiEdit = generate.idPegawai

            let data = this.dataFungsi
            let fungsi = generate.fungsi
            
            var i = 0
            for(i=0;i<data.length;i++) {
                if(fungsi == data[i].value) {
                    this.selectedFungsi.value = data[i].value
                    this.selectedFungsi.text = data[i].text
                }
            }
            this.getDataAddPegawai(generate.idPegawai)
            this.rupiahModeUangSaku('saku')
            this.rupiahModeUangSaku('makan')
            this.rupiahModeUangSaku('komunikasi')
            this.rupiahModeUangSaku('reimburse')
            this.rupiahModeUangSaku('suplisi')
            this.rupiahModeUangSaku('iuranBpjs')
            this.rupiahModeUangSaku('faktorPengurang')
            this.tipe = 'U'
            this.unix = generate.unix
            this.moving()
        },

        submitForm() {
            this.$v.$touch()
            if(this.$v.$invalid) {
                if (
                    this.$v.queryAddPegawai.$invalid ||
                    this.$v.uangSaku.$invalid ||
                    this.$v.uangMakan.$invalid ||
                    this.$v.uangKomunikasi.$invalid ||
                    this.$v.tanggalAktif.$invalid ||
                    this.$v.tanggalNonAktif.$invalid ||
                    this.$v.selectedFungsi.$invalid ||
                    this.$v.uangReimburse.$invalid ||
                    this.$v.sekolah.$invalid ||
                    this.$v.nomorRekening.$invalid ||
                    this.$v.namaBank.$invalid ||
                    this.$v.namaPemilik.$invalid
                ) {
                    //
                } else {
                    if(this.$v.io.$invalid && this.selectedFungsi.value == 'Coop') {
                        if (this.$v.prk.$invalid) {
                            //
                        } else {
                            this.io = ''
                            this.goSave()
                            this.loading = true
                        }
                    }
                    if(this.$v.prk.$invalid && this.selectedFungsi.value == 'Aktivasi') {
                        if (this.$v.io.$invalid) {
                            //
                        } else {
                            this.prk = ''
                            this.goSave()
                            this.loading = true
                        }
                    }
                    if(this.$v.prk.$invalid && this.$v.io.$invalid && this.selectedFungsi.value == 'Aset') {
                        this.prk = ''
                        this.io = ''
                        this.goSave()
                        this.loading = true
                    }
                }
            } else {
                this.goSave()
                this.loading = true
            }
        },
        getDataFungsi() {
            this.dataFungsi = [
                { text: 'Aset', value: 'Aset' },
                { text: 'Coop', value: 'Coop' },
                { text: 'Aktivasi', value: 'Aktivasi' },
            ]
        },
        getSearchDataFungsi() {
            this.searchDataFungsi = [
                { text: 'Semua', value: '' },
                { text: 'Aset', value: 'Aset' },
                { text: 'Coop', value: 'Coop' },
                { text: 'Aktivasi', value: 'Aktivasi' },
            ]
        },
        goDelete() {
            this.deleteModal = true
        },
        onDelete() {
            this.goSave()
        },
        cancelDelete() {
            this.deleteModal = false
        },
        showCertificate() {
            this.$store.state.loadingScreen = true
            let payload = {
                idPegawai: this.idPegawaiEdit
            }
            DataApi.post("/export/sertifikat/magang/pdf", payload , {responseType: 'blob'})
            .then(res => {
                let response = res.data
                const url = URL.createObjectURL(new Blob([response], {
                    type: 'application/pdf'
                }))
                window.open(url)
                this.$store.state.loadingScreen = false
            })
        },
        showLetter() {
            this.$store.state.loadingScreen = true
            let payload = {
                idPegawai: this.idPegawaiEdit
            }
            DataApi.post("/export/sk/magang/pdf", payload , {responseType: 'blob'})
            .then(res => {
                let response = res.data
                const url = URL.createObjectURL(new Blob([response], {
                    type: 'application/pdf'
                }))
                window.open(url)
                this.$store.state.loadingScreen = false
            })
        },
        getDataUMP() {
            let payload = {
                provinsi: ''
            }
            DataApi.post("magang/umr/lihat", payload)
            .then(res => {
                let response = res.data
                if(response.success == true) {
                    this.dataUMP = response.data
                }
                else {
                    this.dataUMP = []
                    this.errMessage = response.message
                }
            })
        },
        separatorUMP(value) {
            let val = value.toString()
            let leng = val.length
            let sisa 	= leng % 3
            let rupiah 	= val.substr(0, sisa)
            let ribuan 	= val.substr(sisa).match(/\d{3}/g)
                
            if (ribuan) {
                let separator = sisa ? '.' : ''
                rupiah += separator + ribuan.join('.')
            }
            return 'Rp. ' +  rupiah 
        },
        pickUMP(id) {
            let temp = this.dataUMP[id]
            this.uangSaku = temp.totalUmr
            this.rupiahModeUangSaku('saku')
            this.umpModal = false
        }
    },
    mounted() {
        this.errorMessage = 'Find Your Data'
        this.getDataPegawai()
        this.getDataFungsi()
        this.getSearchDataFungsi()
        this.getDataUMP()
    }
}
</script>
<style scoped>
.containers {
    background-color: white;
    border-bottom: 1px solid #e5e6e8;
}
.btn-search {
    border-radius: 4px;
    width: 100%;
    background-color:rgba(48, 107, 221, 1);
    color: white;
}
.btn-search:hover {
    border-radius: 4px;
    width: 100%;
    background-color:rgba(48, 107, 255, 1);
    color: white;
}
.btn-add {
    border-radius: 4px;
    width: 100%;
    border: 1px solid rgba(48, 107, 221, 1);
    background-color:white;
    color: rgba(16, 16, 16, 1);
    font-weight: 500;
    font-size: 14px;
}
.btn-add:hover {
    border-radius: 4px;
    width: 100%;
    border: 1px solid rgba(48, 107, 221, 1);
    background-color: rgba(48, 107, 221, 1);
    color: white;
}
.btn-cancel {
    border-radius: 4px;
    width: 200px;
    float: left;
    border: 1px solid rgba(48, 107, 221, 1);
    background-color:white;
    color: rgba(16, 16, 16, 1);
    font-weight: 500;
    font-size: 14px;
}
.btn-cancel:hover {
    border-radius: 4px;
    width: 200px;
    float: left;
    border: 1px solid rgba(48, 107, 221, 1);
    background-color: rgba(48, 107, 221, 1);
    color: white;
}
.btn-edit-delete {
    border-radius: 4px;
    float: left;
    width: 200px;
    background-color:red;
    color: white;
    font-size: 14px;
}
.reloadOn {
    float: left;
    cursor: pointer;
    transform: rotate(-180deg);
    transition: 300ms linear all;
}
.reloadOff {
    float: left;
    cursor: pointer;
    transform: rotate(180deg);
    transition: 300ms linear all;
}
div.search-area {
    padding-top: 12px;
    padding-left: 20px;
    padding-right: 20px;
    padding-bottom: 6px !important;
    background-color: white;
    z-index: 1;
}
div.sticky1 {
    position: -webkit-sticky;
    position: sticky;
    top: 54px;
    padding-top: 6px;
    padding-right: 20px;
    padding-left: 20px;
    padding-bottom: 12px !important;
    background-color: white;
    z-index: 1;
}
input {
    background-color: rgba(249, 250, 252, 1);
}
.area-edit {
    background-color: white;
    border-bottom: 1px solid rgba(238, 238, 238, 1);
}
.area-back {
    padding-left: 20px;
    padding-right: 20px;
    padding-top: 8px;
    padding-bottom: 8px;
}
.area-input {
    padding-left: 20px;
    padding-right: 20px;
    padding-top: 8px;
    padding-bottom: 8px;
}
.area-input label {
    font-size: 12px;
    color: rgba(154, 154, 154, 1);
    font-weight: 600;
    margin-bottom: 12px;
}
.area-input input, .area-input .model-select, .area-input .autocomplete {
    background-color: white;
    margin-bottom: 20px;
}
.area-button-submit {
    padding-left: 20px;
    padding-bottom: 20px;
    padding-top: 32px;
}
.select-invalid {
    border: 1px solid #e55353 !important;
}
.select-valid {
    border: 1px solid #2eb85c !important;
}
.btn-edit-submit {
    border-radius: 4px;
    float: left;
    width: 200px;
    background-color:rgba(48, 107, 221, 1);
    color: white;
    font-size: 14px;
}
.cards-image {
    position: absolute;
    text-align: center;
    font-size: 27px;
    color: rgba(96, 96, 96, 1);
    line-height: 50px;
    border: 1px dotted rgba(221, 221, 221, 1);
    width: 56px !important;
    background-color: rgba(250, 250, 250, 1);
    height: 56px !important;
}


.autocomplete {
    width: 100%;
    position: relative;
}
.input {
    cursor: text;
}
.close {
    position: absolute;
    right: 8px;
    top: 10px;
    background: none;
    border: none;
    font-size: 14px;
    color: lightgrey;
    cursor: pointer;
}
.placeholder {
    position: absolute;
    top: 7px;
    left: 16px;
    font-size: 14px;
    color: #d0d0d0;
}
.popovers {
    text-align: center;
    width: 100% !important;
    min-height: 50px;
    border: 1px solid #d8dbe0;
    position: absolute;
    top: 35px;
    padding-left: 8px;
    padding-right: 8px;
    padding-top: 8px;
    left: 0;
    right: 0;
    background: #fff;
    border-radius: 3px;
    text-align: center;
    z-index: 3;
}
.popovers input {
    right: 8px;
    left: 8px;
    width: 100%;
}
.options {
    max-height: 200px;
    overflow-y: auto;
    margin-top: 5px;
}
.options ul {
    list-style-type: none;
    text-align: left;
    padding-left: 0;
}
.options ul li {
    border-bottom: 1px solid lightgrey;
    padding: 10px;
    cursor: pointer;
    background: white;
}
.options ul li:first-child {
    border-top: 1px solid lightgray;
}
.options ul li:not(.selected):hover {
    background: whitesmoke;
    color: rgba(16, 16, 16, 1);
}
.options ul li.selected {
    background: whitesmoke;
    color: rgba(16, 16, 16, 1);
}
input:disabled {
    background-color: whitesmoke;
}

::v-deep .modal-header {
    border-bottom: none !important;
}
.headers-modal {
    padding-top: 32px;
    padding-bottom: 32px;
    padding-left: 20px;
    padding-right: 20px;
    font-size: 18px;
    font-weight: bold;
    color: rgba(16, 16, 16, 1);
}

</style>